<template>
  <div>
    <a href="javascript:void(0);"><em class="fa fa-trash middle" @click="onDeleteStock" /></a>
    <input
      type="text"
      class="form-control"
      id="optionInput"
      placeholder="Option"
      v-model="stock.option"
      style="width: 100px; display: inline-block"
    />
    <a
      href="javascript:void(0);"
      class="btn btn-default btn-xs btn-none-radius"
      style="padding: 4px 5px 1px 5px; font-size: 10px"
      @click="removeCount(index)"
      :disabled="stock.quantity == min"
    >
      <span class="glyphicon glyphicon-minus"></span>
    </a>
    <input
      type="text"
      maxlength="3"
      pattern="[0-9]*"
      inputmode="numeric"
      class="form-control"
      id="quantityInput"
      placeholder="Quantity"
      v-model="stock.quantity"
      style="
        width: 55px;
        display: inline-block;
        margin-left: 5px;
        margin-right: 5px;
        text-align: center;
      "
    />
    <a
      href="javascript:void(0);"
      class="btn btn-default btn-xs btn-none-radius"
      style="padding: 4px 5px 1px 5px; font-size: 10px"
      @click="addCount(index)"
      :disabled="stock.quantity == max"
    >
      <span class="glyphicon glyphicon-plus"></span>
    </a>

    <a href="javascript:void(0);" class="btn btn-primary" @click="onAddStock">Add</a>
  </div>
</template>

<script>
export default {
  props: ['max', 'min'],
  data: function () {
    return {
      stock: {
        option: null,
        quantity: 0
      }
    }
  },
  methods: {
    onAddStock: function () {
      this.$emit('onAddStock', this.stock)
      this.stock = {
        option: null,
        quantity: 0
      }
    },
    onDeleteStock: function () {
      this.$emit('onDeleteStock')
      this.stock = {
        option: null,
        quantity: 0
      }
    },
    removeCount: function () {
      if (this.stock.quantity > this.min) {
        this.stock.quantity = parseInt(this.stock.quantity) - 1
      }
    },
    addCount: function () {
      if (this.stock.quantity < this.max) {
        this.stock.quantity = parseInt(this.stock.quantity) + 1
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ananda/AddStock.vue